import React from 'react';

export default function Component (props){
  const { days, style = {} } = props;
  return (
      <div style={{ display: 'flex', flex: 1, flexDirection: 'row', ...style }}>
        {days.map((item)=>{
          return (
            <div key={item.number} style={{ flexDirection: 'column', width: 20, marginRight: 5, textAlign: 'center' }}>
              <div> {item.number} </div>
              <div style={{ fontSize: 10 }}> {item.weekday.slice(0, 3)} </div>
            </div>
          );
        })}
      </div>
  );
}
